// import { AppBar, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Modal, Toolbar, Typography, useTheme } from '@mui/material'
// import React, { memo } from 'react'
// import CloseIcon from '@mui/icons-material/Close';

// function AppModal({ open, handleClose, children }) {
//     const { palette } = useTheme()
//     return (
//         <Dialog fullScreen open={open} onClose={handleClose}>
//             <DialogContent sx={{ padding: 0, margin: 0 }}>
//                 <IconButton size='small' sx={{ display: "flex", marginLeft: "auto", alignSelf: "center" }} onClick={handleClose}>
//                     <CloseIcon />
//                 </IconButton>
//                 {children}
//             </DialogContent>
//         </Dialog>
//     )
// }

// export default memo(AppModal)

// 2.

// import {
//   Dialog,
//   DialogContent,
//   IconButton,
//   Box,
// } from "@mui/material";
// import React, { memo } from "react";
// import CloseIcon from "@mui/icons-material/Close";

// function AppModal({ open, handleClose, children }) {
//   return (
//     <Dialog
//       fullScreen
//       open={open}
//       onClose={handleClose}
//       PaperProps={{
//         sx: {
//           height: "100vh",
//           width: "100vw",
//           margin: 0,
//         },
//       }}
//     >
//       <DialogContent
//         sx={{
//           p: 0,
//           m: 0,
//           height: "100vh",
//           width: "100vw",
//           overflow: "hidden",
//           position: "relative",
//         }}
//       >
//         {/* CLOSE ICON */}
//         <IconButton
//           onClick={handleClose}
//           sx={{
//             position: "absolute",
//             top: 8,
//             right: 8,
//             zIndex: 10,
//             bgcolor: "background.paper",
//             boxShadow: 1,
//             "&:hover": { bgcolor: "grey.200" },
//           }}
//         >
//           <CloseIcon />
//         </IconButton>

//         {/* FULL SCREEN CONTENT WRAPPER */}
//         <Box
//           sx={{
//             height: "100%",
//             width: "100%",
//             display: "flex",
//             flexDirection: "column",
//           }}
//         >
//           {children}
//         </Box>
//       </DialogContent>
//     </Dialog>
//   );
// }

// export default memo(AppModal);

// 3.

import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
} from "@mui/material";
import React, { memo } from "react";
import CloseIcon from "@mui/icons-material/Close";

function AppModal({ open, handleClose, children }) {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          height: "100vh",
          width: "100vw",
          margin: 0,
        },
      }}
    >
      <DialogContent
        sx={{
          p: 2, // Modal के अंदर थोड़ा Padding दिया गया है
          m: 0,
          height: "100vh",
          width: "100vw",
          overflowX: "auto", // 🛑 Horizontal Scroll Enable किया गया
          overflowY: "auto", // Vertical Scroll भी जरूरत होने पर काम करेगा
          position: "relative",
          boxSizing: "border-box",
        }}
      >
        {/* CLOSE ICON */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: "fixed", // Absolute की जगह Fixed ताकि Scroll करने पर Cross Icon गायब न हो
            top: 16,
            right: 16,
            zIndex: 1000,
            bgcolor: "background.paper",
            boxShadow: 2,
            "&:hover": { bgcolor: "grey.200" },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* FULL SCREEN CONTENT WRAPPER */}
        <Box
          sx={{
            minHeight: "100%",
            width: "max-content", // 🛑 Content की पूरी Width (Scroll Area) बनाए रखने के लिए
            minWidth: "100%",
            display: "flex",
            flexDirection: "column",
            pt: 4, // Close Icon से ओवरलैप न हो इसलिए Top Padding
          }}
        >
          {children}
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default memo(AppModal);
